import React, { useRef, useState } from "react";
import axios from "axios";
import { API_DOCTOR_CREATE } from '../../../../helpers/urlHelper';

const inputStyle = {
    padding: "16px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #E0E0E0",
    backgroundColor: "#ffffffff",
    width: "100%",
};

export default function AddNew() {
    const [formData, setFormData] = useState({
        name: "",
        surname: "",
        phone: "",
        email: '',
        license: "",
        customid: "",
        experienceYears: "",
        experienceMonths: "",
        feesFrom: "",
        feesUpto: "",
        specialty: "",
    });
    const [pictureFile, setPictureFile] = useState(null);
    const [certFiles, setCertFiles] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const fileInputRef = useRef();
    const certInputRef = useRef();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handlePictureSelect = (e) => setPictureFile(e.target.files[0]);
    const handleCertSelect    = (e) => setCertFiles(Array.from(e.target.files));

    const handleSubmit = async () => {
        console.log("Email:", formData.email);
        setIsSubmitting(true);
        try {
            const payload = new FormData();
            payload.append("name", formData.name);
            payload.append("surname", formData.surname);
            payload.append("phone", formData.phone);
            payload.append('email', formData.email);
            payload.append("license", formData.license);
            payload.append("customid", formData.customid);
            payload.append("experienceInYears", formData.experienceYears || "0");
            payload.append("experienceInMonths", formData.experienceMonths || "0");
            payload.append("feesFrom", formData.feesFrom || "0");
            payload.append("feesUpto", formData.feesUpto   || "0");
            formData.specialty
                .split(",")
                .map(s => s.trim())
                .filter(Boolean)
                .forEach(s => payload.append("services", s));
            if (pictureFile) payload.append("image", pictureFile);
            certFiles.forEach(file => payload.append("uploads", file));
            payload.append("role", "doctor");
            payload.append("isActive", "true");

            await axios.post(API_DOCTOR_CREATE, payload, {
                headers: { 'Content-Type': 'application/json' },
            });

            alert("Doctor creado correctamente");
            window.location.reload();
        } catch (err) {
            console.error("Error creando doctor:", err);
            const apiMsg = err.response?.data?.message || err.message;
            alert(`Error al crear doctor: ${apiMsg}`);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div
            className="offcanvas offcanvas-end d-flex flex-column"
            tabIndex={-1}
            id="addNew"
            aria-labelledby="offcanvasRightLabel"
            style={{ minWidth: '800px' }}
        >
            <div className="offcanvas-header">
                <h5 className="offcanvas-title">Add Doctor</h5>
                <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
            </div>

            <div className="offcanvas-body flex-grow-1 overflow-auto px-4 mt-4">
                <h6 className="fw-bold mb-4">Core Information's</h6>

                <div className="d-flex mb-4">
                    <div style={{minWidth: 200}}>
                        <div
                            className="d-flex flex-column align-items-center justify-content-center"
                            style={{
                                height: 200,
                                width: 200,
                                border: "2px dashed #D9D9D9",
                                borderRadius: 12,
                                cursor: "pointer",
                            }}
                            onClick={() => fileInputRef.current.click()}
                        >
                            {pictureFile ? (
                                <img
                                    src={URL.createObjectURL(pictureFile)}
                                    alt="Preview"
                                    style={{maxHeight: "100%", maxWidth: "100%", borderRadius: 12}}
                                />
                            ) : (
                                <>
                                    <i className="bi bi-cloud-arrow-up" style={{fontSize: 32, color: "#AAA"}}/>
                                    <small className="text-secondary mt-2">Profile Picture</small>
                                    <small className="text-muted">Max 20 MB PDF</small>
                                </>
                            )}
                            <input
                                type="file"
                                accept="image/*,application/pdf"
                                ref={fileInputRef}
                                style={{display: "none"}}
                                onChange={handlePictureSelect}
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>

                    <div className="flex-grow-1 ms-4">
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Fast Name</label>
                                <input
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter your fast name"
                                    style={inputStyle}
                                    disabled={isSubmitting}
                                    required
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Last name</label>
                                <input
                                    name="surname"
                                    value={formData.surname}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter your last name"
                                    style={inputStyle}
                                    disabled={isSubmitting}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Phone Number</label>
                                <input
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter phone no"
                                    style={inputStyle}
                                    disabled={isSubmitting}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label fw-bold">Email Id</label>
                                <input
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    type="email"
                                    placeholder="Enter email"
                                    style={inputStyle}
                                    disabled={isSubmitting}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row g-3 mb-4">
                    <div className="col-md-6">
                        <label className="form-label fw-bold">License no.</label>
                        <input
                            name="license"
                            value={formData.license}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter number"
                            style={inputStyle}
                            disabled={isSubmitting}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Doctor ID</label>
                        <input
                            name="customid"
                            value={formData.customid}
                            onChange={handleChange}
                            type="text"
                            placeholder="Add ID"
                            style={inputStyle}
                            disabled={isSubmitting}
                        />
                    </div>
                </div>

                <div className="row g-3 mb-4">
                    <div className="col-12">
                        <label className="form-label fw-bold">Total Experience</label>
                        <div className="d-flex gap-3">
                            <input
                                name="experienceYears"
                                value={formData.experienceYears}
                                onChange={handleChange}
                                type="number"
                                placeholder="Year"
                                style={{...inputStyle, flex: 1}}
                                disabled={isSubmitting}
                            />
                            <input
                                name="experienceMonths"
                                value={formData.experienceMonths}
                                onChange={handleChange}
                                type="number"
                                placeholder="Month"
                                style={{...inputStyle, flex: 1}}
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                </div>

                <div className="row g-3 mb-4">
                    <div className="col-12">
                        <label className="form-label fw-bold">Fees Range</label>
                        <div className="d-flex gap-3">
                            <input
                                name="feesFrom"
                                value={formData.feesFrom}
                                onChange={handleChange}
                                type="number"
                                placeholder="From"
                                style={{...inputStyle, flex: 1}}
                                disabled={isSubmitting}
                            />
                            <input
                                name="feesUpto"
                                value={formData.feesUpto}
                                onChange={handleChange}
                                type="number"
                                placeholder="Upto"
                                style={{...inputStyle, flex: 1}}
                                disabled={isSubmitting}
                            />
                        </div>
                    </div>
                </div>

                <div className="mb-4">
                    <label className="form-label fw-bold">Specialty</label>
                    <textarea
                        name="specialty"
                        value={formData.specialty}
                        onChange={handleChange}
                        rows={4}
                        placeholder="Add specialty"
                        style={{...inputStyle, resize: "none"}}
                        disabled={isSubmitting}
                    />
                </div>

                <div className="mb-5">
                    <h6 className="fw-bold mb-2">Certificates</h6>
                    <div
                        className="d-flex flex-column align-items-center justify-content-center"
                        style={{
                            height: 150,
                            width: "100%",
                            border: "2px dashed #D9D9D9",
                            borderRadius: 12,
                            cursor: "pointer",
                        }}
                        onClick={() => certInputRef.current.click()}
                    >
                        {certFiles.length > 0 ? (
                            <small className="text-success">
                                {certFiles.length} archivo(s) seleccionado(s)
                            </small>
                        ) : (
                            <>
                                <i className="bi bi-cloud-arrow-up" style={{fontSize: 28, color: "#AAA"}}/>
                                <small className="text-secondary mt-2">Upload certificates</small>
                            </>
                        )}
                        <input
                            type="file"
                            accept=".pdf,image/*"
                            multiple
                            ref={certInputRef}
                            style={{display: "none"}}
                            onChange={handleCertSelect}
                            disabled={isSubmitting}
                        />
                    </div>
                </div>
            </div>

            <div className="p-3 border-top d-flex justify-content-between">
                <button
                    type="button"
                    className="btn btn-outline-primary px-4"
                    data-bs-dismiss="offcanvas"
                    disabled={isSubmitting}
                >
                    Close
                </button>
                <button
                    type="button"
                    className="btn btn-primary px-4"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? "Saving..." : "Save"}
                </button>
            </div>
        </div>
    );
}
